export class ChartDataHelper {
    constructor (chartData) {
        this.chartData = chartData;
    }

    get type () {
        return this.chartData.chartType;
    }

    get settings () {
        return this.chartData.settings;
    }

    get metric () {
        return this.chartData.meta.metric;
    }

    get dataSeries () {
        const result = {};
        this.chartData.data.forEach(el => {
            const series = this.getSeries(el[this.chartData.meta.series]);
            if (series && series.visible) {
                if (!result[series.id]) {
                    result[series.id] = {
                        series: series.id,
                        metric: []
                    };
                }
                result[series.id].metric.push(
                    this.chartData.meta.metric.reduce((metric, val, idx) => {
                        metric[idx] = el[val] || 0;
                        return metric;
                    }, [])
                );
            }
        });
        return Object.values(result) || [];
    }

    get maxMetrics () {
        var max = Array(this.metric.length).fill(null);
        for (const el of this.dataSeries) {
            for (const el2 of el.metric) {
                for (const [idx, val] of el2.entries()) {
                    if (max[idx] === null || val > max[idx]) {
                        max[idx] = val;
                    }
                }
            }
        }
        return max;
    }

    get minMetrics () {
        var min = Array(this.metric.length).fill(null);
        for (const el of this.dataSeries) {
            for (const el2 of el.metric) {
                for (const [idx, val] of el2.entries()) {
                    if (min[idx] === null || val < min[idx]) {
                        min[idx] = val;
                    }
                }
            }
        }
        return min;
    }

    getSeries (seriesId) {
        const series = this.chartData.settings.series.find(s => s.id === seriesId);
        return series;
    }

    getSeriesColour (seriesId) {
        const series = this.getSeries(seriesId);
        return series && series.colour;
    }

    getSeriesName (seriesId) {
        const series = this.getSeries(seriesId);
        return series && series.name;
    }
}
